import React from 'react'
import UtilityToolbarDropdown from 'src/components/DataGrid/UtilityToolbar/UtilityToolbarDropdown'
import ReceiptToolsDropdownUtilityToolbar from 'src/components/ReceiptToolsDropdown/ReceiptToolsDropdownUtilityToolbar'
import Trns from 'src/localization/Trns'
import { OrganizationsListModel } from 'src/models/organizations.models'

interface ReceiptToolsLayoutShellButtonProps {
  organization: OrganizationsListModel
  hasReceiptRulePermissions: boolean
}

const ReceiptToolsLayoutShellButton: React.FC<
  ReceiptToolsLayoutShellButtonProps
> = (props): React.ReactElement => {
  return (
    <UtilityToolbarDropdown
      buttonText={<Trns source={'Receipt Tools'} />}
      dropdown={
        <ReceiptToolsDropdownUtilityToolbar
          organization={props.organization}
          hasReceiptRulePermissions={props.hasReceiptRulePermissions}
        />
      }
      testId={'receiptToolsDropdown'}
      alignment={'right'}
      buttonVariant={'primary'}
    />
  )
}

export default ReceiptToolsLayoutShellButton
